<!-- eslint-disable vue/no-parsing-error -->
<template>
  <div>
    <v-app-bar app :elevate-on-scroll="true" height="50">
      <v-row dense class="d-flex justify-space-between">
        <v-col cols="auto" class="d-flex order-first order-sm-0">
          <div>
            <v-btn icon>
              <v-icon small color="primary" @click="toggleBooleanValue">
                {{
                  booleanValue
                    ? "fas fa-angle-double-left"
                    : "fas fa-angle-double-right"
                }}
              </v-icon>
            </v-btn>
          </div>
        </v-col>

        <v-col cols="auto" class="d-flex align-center justify-end">


          <!-- CAJITA DE SESION -->
          <v-row dense>
            <v-col cols="auto">
              <!-- SUCURSALES -->
              <v-menu left bottom
                v-if="Sucurales.length > 0 && (datoLogin.webmaster == 1 || datoLogin.licencia_perfil == 'director general' || datoLogin.licencia_perfil == 'cordinador general' || datoLogin.licencia_perfil == 'webmaster')">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn small color="warning" v-bind="attrs" v-on="on">
                    <div class="text-center text-capitalize">
                      Surcusales
                    </div>
                    <v-icon right small>fa-graduation-cap</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list dense>
                    <v-subheader>Selecciona sucursal:</v-subheader>
                    <v-divider></v-divider>
                    <v-list-item-group v-model="selectedSucursal" @change="changeUserSucursal(selectedSucursal)"
                      color="primary">
                      <v-list-item v-for="(dato, i) in Sucurales" :key="i" :value="dato">
                        <v-icon left small>fas fa-location-arrow</v-icon>
                        <v-list-item-content>
                          <v-list-item-title>{{ dato.nombre_colegio }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="auto" class="d-flex gap-15px justify-center align-center">
              <v-badge :content="unreadCount" :value="unreadCount" color="success" overlap>
                <v-btn small icon>
                  <v-icon color="orange" small @click="verNotif = true">
                    fas fa-bell
                  </v-icon>
                </v-btn>
              </v-badge>

              <a>
                <v-img width="20" src="../../public/checklist.png" @click="verPend = true"
                  v-if="datoLogin.licencia_perfil == 'estudiante' || datoLogin.licencia_perfil == 'familiar'"></v-img>
              </a>
              <!-- <ButtonComp icon-but="   fas fa-clipboard-list" 
                tooltip-text="Actividades pendientes"
                
                classColor="primary" /> -->

            </v-col>
            <v-col cols="auto">
              <v-menu v-model="sesionBox" :close-on-content-click="false" offset-x>
                <template v-slot:activator="{ on }">
                  <v-row dense v-on="on">
                    <v-col cols="8">
                      <v-row dense>
                        <v-col cols="12" class="py-0 d-flex justify-center text-subtitle-2">
                          {{ datoLogin.nombre_persona.split(" ")[0] + " " }}
                          {{ datoLogin.nombre_persona.length + datoLogin.ape1_persona.length < 20 ?
                            datoLogin.ape1_persona : "." + datoLogin.ape1_persona.substr(0, 1) }} </v-col>
                            <v-col cols="12" class="py-0 d-flex justify-center text-caption">
                              {{ datoLogin.descripcion_perfil }}
                            </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="4" class="d-flex gap-10px justify-center align-center">
                      <v-avatar size="25">
                        <img dark :src="datoLogin.ruta_avatar_persona === null ||
                          datoLogin.ruta_avatar_persona === 'null' ||
                          datoLogin.ruta_avatar_persona === undefined ||
                          URL_SPACE === null ? require('@/assets/avatar_us.jpg')
                          : `${URL_SPACE}/${datoLogin.ruta_avatar_persona}`" class="avatar-image"
                          @error="setDefaultAvatar" />
                      </v-avatar>
                      <v-icon x-small> {{ sesionBox ? 'fas fa-angle-up' : 'fas fa-angle-down ' }} </v-icon>

                    </v-col>
                  </v-row>
                </template>
                <v-card class="mx-auto" width="260" tile>
                  <v-system-bar color="primary" />
                  <v-list>

                    <v-list-item class="d-flex justify-center">
                      <v-list-item-avatar size="80">
                        <img
                          :src="datoLogin.ruta_avatar_persona ? `${URL_SPACE}/${datoLogin.ruta_avatar_persona}` : require('@/assets/avatar_us.jpg')"
                          class="avatar-image" @error="setDefaultAvatar" />
                      </v-list-item-avatar>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-content>
                        <div class="blue--text text-center text-capitalize mb-3">
                          {{
                            datoLogin.nombre_persona + " " + datoLogin.ape1_persona + " " + datoLogin.ape2_persona
                          }}
                        </div>

                        <div class="d-flex justify-center">

                          <!-- Si su perfil es 2 significa que es web maste, es if lo utilizo porque su descripción es muy larga  (Administrador del sitio web / Webmaster)-->
                          <v-chip v-if="datoLogin.id_perfil == 2" outlined class="">
                            Administrador / Webmaster
                          </v-chip>

                          <!-- Si no es web master seguirá mostrando su descripción completa (no tan lagargas como las de web master) -->
                          <v-chip v-else outlined class="">
                            {{ datoLogin.descripcion_perfil }}
                          </v-chip>

                        </div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-divider />
                  <v-list nav dense>
                    <v-list-item-group>
                      <v-list-item @click="cambiarContrasena">
                        <v-list-item-icon>
                          <v-icon small color="primary">fas fa-lock</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Cambiar contraseña
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="logout">
                        <v-list-item-icon>
                          <v-icon small color="red">fas fa-power-off</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title> Cerrar sesión </v-list-item-title>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                </v-card>
              </v-menu>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-app-bar>

    <v-navigation-drawer width="350" app v-model="verNotif" fixed temporary right>
      <v-row dense>
        <v-col cols="12">
          <v-tabs v-model="tab" dense>
            <v-tab>
              Notificaciones
            </v-tab>
            <v-tab>
              Mensajeria
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item class="py-4">
              <notificacions @update-unread-count="updateUnreadCount" />
            </v-tab-item>
            <v-tab-item class="py-4">
              <notificationsPers />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-navigation-drawer>

    <v-navigation-drawer width="350" app v-model="verPend" fixed temporary right>
      <v-row dense>
        <v-col cols="12" v-if="datoLogin.licencia_perfil == 'estudiante'">
          <pendientes />
        </v-col>
        <v-col cols="12" v-if="datoLogin.licencia_perfil == 'familiar'">
          <pendientesFam />
        </v-col>
      </v-row>
    </v-navigation-drawer>
    <!-- modal cambio de password-->
    <v-dialog v-model="modal_password" persistent scrollable max-width="400px">
      <v-card>
        <v-card-title class="btn_otro">
          <label>Cambio de contraseña</label>
          <v-spacer />
          <v-btn fab dark x-small class="btn_style3" @click="modal_password = false"><v-icon
              dark>fa-times</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pt-5">
          <v-row class="py-2">
            <v-col cols="12" class="">
              <v-text-field v-model="pUsuario.password" label="Contraseña actual" type="password" dense hide-details
                autocomplete="off" autofocus ref="password">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-text-field v-model="pUsuario.newPassword" label="Nueva contraseña" type="password" dense hide-details
                autocomplete="off" ref="newPassword">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <v-text-field v-model="pUsuario.rePassword" label="Confirme la contraseña" type="password" dense
                hide-details autocomplete="off" ref="rePassword">
              </v-text-field>
            </v-col>
            <v-col cols="12" class="pb-0">
              <span style="font-size: 12px">
                La nueva contraseña debe tener entre 8 y 16 caracteres e incluir al menos una letra mayúscula, una
                minúscula y un dígito
              </span>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="btn_style3" dark tile @click="closePassword">Cancelar</v-btn>
          <v-btn class="btn_block_style2" dark tile @click="submitConfirm">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex"; // mapGetters, mapState 
import axios, { BUCKET_ORIGIN_SPACE } from "../helpers/axios";
import ButtonComp from "../components/ComponentsEst/TableButtonComp.vue";
import notificacions from './notificacions.vue';
import notificationsPers from "./notificationsPers.vue";
import pendientes from './pendientes.vue';
import pendientesFam from './pendientesFam.vue';
export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ButtonComp,
    notificacions,
    pendientes,
    pendientesFam,
    notificationsPers
  },
  props: {
    booleanValue: {
      type: Boolean,
      required: true,

    },
  },
  name: "Header",

  namespaced: true,
  data: () => ({

    // PROPIEDADES GENERALES
    datoLogin: sessionStorage,
    URL_SPACE: BUCKET_ORIGIN_SPACE,
    verNotif: false,
    verPend: false,
    unreadCount: 0,
    tab: 0,
    i18n: [],
    viewPerfil: false,
    dataNamesSubMod: {},

    //PROPIEDADES DE CAMBIO PASSWORD:
    modal_password: false,
    pUsuario: {
      password: "",
      newPassword: "",
      rePassword: "",
    },
    //PROPIEDADES DE SUCURSALES:
    Sucurales: [],
    selectedSucursal: null,
    sesionBox: false,
    message: false,

  }),

  mounted() {
    this.loadMain();
  },
  methods: {
    ...mapMutations({
      setEnviarMens: "mensajeSis/setEnviarMens",
    }),
    ...mapActions({
      logout: "login/logout",
      verificarSession: "login/verificarSession",
      LogoUrl: "LogoUrl",
    }),
    /** 
     ____________________________________
    |          MÉTODO INICIAL          */
    async loadMain() {
      await this.set_breadcrumb();
      // this.i18nMethod();
      this.getSucursal(this.datoLogin.id_colegio);
    },
    /** 
     _____________________________________________
    |          MÉTODO AVATAR SI ES 404          */
    setDefaultAvatar(event) {
      event.target.src = require('@/assets/avatar_us.jpg');
    },

    /** 
     __________________________________________________________
    |          MÉTODO ABRIR O CERRAR SIDEBAR O MENU          */
    toggleBooleanValue() {
      this.$emit("toggle-value");
    },
    /** 
    _____________________________________________
   |          MÉTODO CAMBIAR PASSWORD          */
    async submitConfirm() {
      if (
        this.pUsuario.password.length > 5 &&
        this.pUsuario.newPassword.length > 5 &&
        this.pUsuario.rePassword.length > 5
      ) {
        if (this.pUsuario.newPassword == this.pUsuario.rePassword) {
          var expreg = /^(?=\w*\d)(?=\w*[A-Z])(?=\w*[a-z])\S{8,16}$/;
          if (expreg.test(this.pUsuario.newPassword)) {
            let params = {
              usuario: this.datoLogin.usu_usuario,
              passwords: this.pUsuario,
            };
            let response = await axios.post(
              `/sistema/usuario/cambioContrasena/`,
              params
            );
            if (JSON.stringify(response.data.mti) == JSON.stringify("S")) {
              this.closePassword();
              this.setEnviarMens({
                tipo: "S",
                mensaje: response.data.message,
                tiempo: null,
              });
            } else {
              this.setEnviarMens({
                tipo: "W",
                mensaje: response.data.message,
                tiempo: null,
              });
            }
          } else {
            this.setEnviarMens({
              tipo: "W",
              mensaje: `La nueva contraseña no cumple los requisitos mínimos`,
              tiempo: null,
            });
          }
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: `La nueva contraseña y la confirmación no coinciden`,
            tiempo: null,
          });
        }
      } else {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Los campos deben contener información`,
          tiempo: null,
        });
      }
    },
    /** 
    _______________________________________________________________________
   |          MÉTODO OBTENER SUCURSALES PADRES Y SUCURSALES HIJAS        */
    async getSucursal(idcolegio) {
      try {

        const response = await axios.get(`/manager/colegio/Allsucursales/${idcolegio}`)
        this.Sucurales = response.data.datosSibling;

        // console.log(response.data);

      } catch (error) {
        console.log(error);
      }
    },
    /** 
    ________________________________________________________
   |          MÉTODO CAMBIAR USUARIO POR SUCURSAL         */
    async changeUserSucursal(datosColegio) {

      const id_usuario = parseInt(this.datoLogin.id, 10);
      const id_colegio = parseInt(datosColegio.id, 10);
      const desc_rol = this.datoLogin.licencia_perfil;

      try {
        const response = await axios.put(`/sistema/main/validarUsuarioSucursal/${id_usuario}/${id_colegio}/${desc_rol}`)

        if (response.data.messageT == "S") {
          console.log('entro');
          this.verificarSession({ id: id_usuario, sistema: "", taken: "" })
          this.getSucursal(id_colegio);
          this.selectedSucursal = null;
        } else {
          this.setEnviarMens({
            tipo: "W",
            mensaje: response.data.message,
            tiempo: null,
          });
        }

      } catch (error) {
        console.log(error);
      } finally {
        // setTimeout(() => {
        //   this.$router.push('/colegio');

        // }, 5000);
      }
    },
    /** 
    ____________________________________________________________________
   |          MÉTODO I18N PARA INTERPRETAR STRINGS SUBMODULOS         */
    async i18nMethod() {
      if (this.datoLogin.id_us_idioma) {
        try {
          let resp = await axios.get(`/sistema/i18n/`);
          this.i18n = resp.data;
          // Asigna Idioma al select del Header
          this.dataNamesSubMod.id_i18n = this.datoLogin.id_us_idioma;
          this.dataNamesSubMod = Object.assign(
            {},
            { id_i18n: parseInt(this.datoLogin.id_us_idioma) }
          );
          // cargar I18 nde sesion
          let idiomaLocale = this.i18n.filter(
            (el) => el.id == this.datoLogin.id_us_idioma
          );
          if (idiomaLocale[0].abreviatura) {
            this.$i18n.locale = idiomaLocale[0].abreviatura;
          }
          let perso = await axios.get(
            "/administrativo/personal/getPersonalPerfil/" +
            this.datoLogin.id_persona
          );
          if (perso.data != null) {
            this.viewPerfil = true;
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: error, tiempo: "null" });
        }
      }
    },
    /** 
    ______________________________________________________________________
   |          MÉTODO DE APERTURA Y CIERRE PARA CAMBIAR PASSWORD         */
    async cambiarContrasena() {
      this.limpiarData();
      this.modal_password = true;
    },
    /** 
    ________________________________________________________________
   |          MÉTODO CERRAR DIALOGO DE CAMBIO DE PASSWORD         */
    closePassword() {
      this.modal_password = false;
    },

    updateUnreadCount(count) {
      // Manejar el número de mensajes sin leer recibido del componente hijo
      this.unreadCount = count;
    },

    /** 
    ____________________________________________________
   |          MÉTODO ESTABLECER MIGAS DE PAN          */
    async set_breadcrumb() {
      const route = this.$route;
      this.bread_crumb = route.meta.breadCrumb.toUpperCase();
    },
    /** 
    ________________________________________________________________
   |          MÉTODO LIMPIAR CAMPOS DE CAMBIO DE PASSWORD         */
    limpiarData() {
      this.pUsuario.password = "";
      this.pUsuario.newPassword = "";
      this.pUsuario.rePassword = "";
    },
  },
};
</script>

<style scoped>
/* .avatar {
  background-position: center;
  background-size: cover;
} */
.item-hover {
  cursor: pointer;
}

.text_style3 {
  font-family: "avenir black" !important;
  letter-spacing: 0.42px;
  font-size: 10px !important;
}

.avatar-image {
  object-fit: contain;
  background: darkgray;
}
</style>